"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Thankyou = require("./Thankyou");

var _Thankyou2 = _interopRequireDefault(_Thankyou);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThankyouPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(ThankyouPopup, _React$Component);

  function ThankyouPopup(props) {
    (0, _classCallCheck3.default)(this, ThankyouPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ThankyouPopup.__proto__ || (0, _getPrototypeOf2.default)(ThankyouPopup)).call(this, props));

    _this.state = {
      msg: null
    };
    _this.triggerPopup = _this.triggerPopup.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ThankyouPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.triggerPopup();
    }
  }, {
    key: "triggerPopup",
    value: function triggerPopup() {
      var msg = this.props.location.query.msg;

      if (msg === "ty") {
        this.context.dialogs.custom(_react2.default.createElement(_Thankyou2.default, null));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("div", null);
    }
  }]);
  return ThankyouPopup;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = ThankyouPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankyouPopup/ThankyouPopup.jsx
// module id = 2855
// module chunks = 0